import React from 'react';

import * as St from './styles';

const Avatar: React.FC<React.ImgHTMLAttributes<HTMLImageElement>> = (props) => {
  return <St.Avatar {...props} />;
};

export default Avatar;
